export const nl = {
    common: {
        USER_NAME_LABEL: 'Volledige naam',
        PIN_CODE_LABEL: 'Pincode',
        comment: 'Opmerking',
        year: 'Jaar',
        configuration: 'Configuratie',
        cancel: 'Annuleren',
        search: 'Zoeken',
        remove: 'Verwijderen',
        confirmationDialogTitle:
            'Weet je zeker dat je dit item wilt verwijderen?',
        selectDate: 'Selecteer datum',
        select: 'Selecteren',
        notFound: 'Niet gevonden',
        equipmentPickerPlaceholder: 'Uitrustingsobject...',
        searchPlaceholder: 'Zoeken...',
        equipmentTypePickerPlaceholder: 'Uitrustingstype...',
        equipmentTypePickerTitle: 'Selecteer uitrustingstype',
        emptyTableMessage: 'Geen gegevens',
        flowPikcerTitle: 'Selecteer stroom',
        selectIcon: 'Selecteer pictogram',
        locationPickerTitle: 'Selecteer locatie',
        locationPlaceholder: 'Locatie...',
        noSublocations: 'Geen sublocaties',
        locationsTitle: 'Locaties',
        edit: 'Bewerken',
        save: 'Opslaan',
        added: 'Toegevoegd',
        updated: 'Bijgewerkt',
        add: 'Toevoegen',
        removed: 'Verwijderd',
        reload: 'Herladen',
        confirm: 'Bevestigen',
        rollBack: 'Terugdraaien',
        images: 'Afbeeldingen',
        documents: 'Documenten',
        download: 'Downloaden',
        saved: 'Opgeslagen',
        date: 'Datum',
        hour: 'Uur',
        preview: 'Voorbeeld',
        data: 'Gegevens',
        attributes: 'Eigenschappen',
        checkList: 'Controlelijst',
        name: 'Naam',
        type: 'Type',
        status: 'Status',
        designation: 'Aanduiding',
        symbol: 'Symbool',
        serialNumber: 'Serienummer',
        registryNumber: 'Registratienummer',
        machineNumber: 'Machine nummer',
        udtNumber: 'UDT-nummer',
        manufacturedYear: 'Fabrieksjaar',
        manufacturer: 'Fabrikant',
        supplier: 'Leverancier',
        mainSupplier: 'Hoofdleverancier',
        attribute: 'Eigenschap',
        nameRequired: 'Naam is verplicht',
        yearGreaterThan: 'Jaar moet groter zijn dan',
        location: 'Locatie',
        fieldRequired: 'Dit veld is verplicht',
        description: 'Beschrijving',
        minimumQuantity: 'Minimum hoeveelheid',
        optimalQuantity: 'Optimale hoeveelheid',
        priority: 'Prioriteit',
        formatYYYY: 'Formaat YYYY',
        storageQuantity: 'Voorraad hoeveelheid',
        quantity: 'Hoeveelheid',
        quantityGreaterThan: 'Hoeveelheid moet groter zijn dan',
        machine: 'Machine',
        tool: 'Gereedschap',
        order: 'Bestelling',
        required: 'Vereist',
        dateFormat: 'Datum formaat',
        selectDictionary: 'Selecteer woordenboek',
        selectDictionaryValue: 'Selecteer woordenboekwaarde',
        return: 'Terug',
        parameters: 'Parameters',
        editCategory: 'Categorie bewerken',
        addCategory: 'Nieuwe categorie toevoegen',
        changeColor: 'Kleur veranderen',
        noColor: 'Geen kleur',
        shift: 'Shift',
        start: 'Start',
        end: 'Einde',
        shiftSchema: 'Schift schema',
        shifts: 'Shifts',
        dictionary: 'Woordenboek',
        subEntries: 'Subvermeldingen',
        key: 'Sleutel',
        value: 'Waarde',
        moveUp: 'Omhoog bewegen',
        moveDown: 'Omlaag bewegen',
        addLocation: 'Nieuwe locatie toevoegen',
        editLocation: 'Locatie bewerken',
        companiesDatabase: 'Bedrijven database',
        flows: 'Stromen',
        read: 'Lezen',
        write: 'Schrijven',
        noImage: 'Geen afbeelding',
        email: 'E-mail',
        function: 'Functie',
        active: 'Actief',
        notActive: 'Niet geactiveerd',
        disabled: 'Uitgeschakeld',
        entryNumber: 'Invoernummer',
        issuedDate: 'Uitgegeven datum',
        expiresDate: 'Verloopt datum',
        move: 'Verplaatsen',
        separateForm: 'Scheiden van',
        separate: 'Scheiden',
        warehouse: 'Magazijn',
        actions: 'Acties',
        putInCurrentLocation: 'Plaats in huidige locatie',
        selectLocationFormRightMenu: 'Selecteer locatie uit het rechter menu',
        showUnassignedItems: 'Toon niet-toegewezen items',
        separated: 'Gescheiden',
        moved: 'Verplaatst',
        categories: 'Categorieën',
        welcome: 'Welkom',
        loginToSignaloCMMS: 'Log in bij Signalo CMMS',
        login: 'Inloggen',
        loginByEmailAndPassword: 'Inloggen met e-mail en wachtwoord',
        loginByCode: 'Inloggen met code',
        accessCode: 'Toegangscode',
        enterEmail: 'Voer e-mail in',
        enterPassword: 'Voer wachtwoord in',
        enterCode: 'Voer code in',
        userNotFound: 'Gebruiker niet gevonden',
        userNotActivated: 'Gebruiker niet geactiveerd',
        userDisabled: 'Gebruiker uitgeschakeld',
        wrongPassword: 'Verkeerd wachtwoord',
        locations: 'Locaties',
        pageNotFound: 'Pagina niet gevonden',
        group: 'Groep',
        yes: 'Ja',
        no: 'Nee',
        hourlyCost: 'Uurkosten',
        price: 'Prijs',
        newEntry: 'Nieuwe invoer',
        predictedFinishTime: 'Voorspelde eindtijd',
        ok: 'Ok',
        archive: 'Archief',
        costs: 'Kosten',
        companyManagement: 'Bedrijfsbeheer',
        companyData: 'Bedrijfsgegevens',
        supportedLanguages: 'Ondersteunde talen',
        en: 'Engels',
        pl: 'Pools',
        es: 'Spaans',
        de: 'Duits',
        it: 'Italiaans',
        fr: 'Frans',
        ru: 'Russisch',
        uk: 'Oekraïens',
        pt: 'Portugees',
        tr: 'Turks',
        nl: 'Nederlands',
        sr: 'Servisch',
        defaultLanguage: 'Standaard taal',
        companyLogo: 'Bedrijfslogo',
        notificationsManagement: 'Notificatiebeheer',
        category: 'Categorie',
        today: 'Vandaag',
        month: 'Maand',
        week: 'Week',
        day: 'Dag',
        close: 'Sluiten',
        show: 'Tonen',
        rollBackFormalConfirmation: 'Formele terugzetbevestiging',
        signUp: 'Registreren',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Label volledige naam',
        userNameSurname: 'Volledige naam',
        userSurnameName: 'Achternaam en voornaam',
        phone: 'Telefoonnummer',
        password: 'Wachtwoord',
        password_confirmation: 'Bevestig wachtwoord',
        unassignedItems: 'Niet toegewezen items',
        currency: 'Valuta',
        general: 'Algemeen',
        timezone: 'Tijdzone',
        users: 'Gebruikers',
        groups: 'Groepen',
        productionLine: 'Productielijn',
        part: 'Onderdeel',
        fittingParts: 'Passende onderdelen',
        workSchema: 'Werkrooster',
        workSchemas: 'Werkroosters',
        holiday: 'Vakantie',
        changePassword: 'Wijzig wachtwoord',
        showRest: 'Toon overige',
        pageNotPermitted: 'Pagina niet toegestaan',
        waitingForActivation: 'Wachtend op activatie',
        editGroup: 'Bewerk groep',
        addGroup: 'Voeg groep toe',
        reportProblem: 'Meld probleem',
        describeOccuredIssue: 'Beschrijf opgetreden probleem',
        markAllAsRead: 'Markeer alles als gelezen',
        unitType: 'Eenheidstype',
        unit: 'Eenheid',
        unitPrice: 'Eenheidsprijs',
        notConfigured: 'Niet geconfigureerd',
        rowsPerPage: 'Rijen per pagina',
        rowsOfPage: 'van',
        true: 'Waar',
        false: 'Onwaar',
        export: 'Exporteren',
        chooseFileFormat: 'Kies bestandsformaat',
        exported: 'Geëxporteerd',
        terminals: 'Terminals',
        terminal: 'Terminal',
        selectEquipment: 'Selecteer apparatuur',
        futureIssues: 'Toekomstige problemen',
        scheduledOn: 'Gepland op',
        planned: 'Gepland',
        notPlanned: 'Niet gepland',
        showOpenIssues: 'Toon open issues',
        pin: 'Pincode',
        assignedEquipment: 'Toegewezen uitrusting',
        terminalEquipment: 'Terminal uitrusting',
        detach: 'Loskoppelen',
        attach: 'Koppelen',
        dashboardConfig: 'Dashboard configuratie',
        addColumn: 'Kolom toevoegen',
        addRow: 'Rij toevoegen',
        removeRow: 'Rij verwijderen',
        registerTerminal: 'Registreer terminal',
        issueGeneratesCost: 'Downtime genereert kosten',
        selectColor: 'Kies kleur',
        belowMinimum: 'Beneden minimum',
        belowOptimum: 'Beneden optimaal',
        synchronization: 'Synchronisatie',
        synchronizationExport: 'Export van voorraad onderdelen',
        synchronizationImport: 'Import van voorraad onderdelen',
        mapping: 'Mapping',
        returnTo: 'Terug naar',
        jobStatusses: 'Processen',
        hidden: 'Verborgen',
        editEvent: 'Gebeurtenis bewerken',
        threeDays: '3 dagen',
        addEvent: 'Gebeurtenis toevoegen',
        plannedIssues: 'Geplande problemen',
        currentService: 'Huidige service',
        searchLocation: 'Locatie zoeken',
        all: 'Alles',
        unfinished: 'Onafgemaakt',
        numberOfIssues: 'Aantal problemen',
        unknown: 'Onbekend',
        partEntry: 'Onderdeel (invoer)',
        foundItems: 'Gevonden items',
        output: 'Output',
        copied: 'Gekopieerd',
        link: 'Link',
        authorizationRequired: 'Autorisatie vereist',
        authorizationRequiredDescriptionUser:
            'Helaas heeft u niet voldoende autorisatie {value}. Vraag een geautoriseerde persoon om de actie te goedkeuren.',
        authorizationRequiredDescriptionTerminal:
            'Gebruik uw toegangscode om de actie te autoriseren.',
        showAll: 'Toon alles',
        showClassicView: 'Toon klassieke weergave',
        noIssuesInCategory: 'Geen problemen in deze categorie.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Aantal problemen in deze categorie en subcategorieën.',
        numberOfIssuesInThisCategory: 'Aantal problemen in deze categorie.',
        minBarcodeLength: 'Minimum barcode lengte',
        currentPage: 'Huidige pagina',
        allPages: "Alle pagina's",
        selectFormat: 'Selecteer formaat',
        provided_currency: 'Aangeboden valuta',
        provided_quantity: 'Aangeboden hoeveelheid',
        provided_unit: 'Aangeboden eenheid',
        provided_unit_price: 'Aangeboden eenheidsprijs',
        unit_price: 'Eenheidsprijs',
        quantity_available: 'Beschikbare hoeveelheid',
        editBarcode: 'Barcode bewerken',
        crews: 'Teams',
        scheduleEventTypes: 'Planningsevent types',
        crew: 'Team',
        scheduleEvent: 'Planningsevent',
        available: 'Beschikbaar',
        'App\\Models\\Crew': 'Team',
        'App\\Models\\User': 'Gebruiker',
        'App\\Models\\Equipment': 'Uitrusting',
        'App\\Models\\Part': 'Deel',
        Crew: 'Team',
        User: 'Gebruiker',
        Equipment: 'Uitrusting',
        Part: 'Deel',
        scheduleEvents: 'Planningsevents',
        event: 'Event',
        externalSystems: 'Externe systemen',
        user: 'Gebruiker',
        availability: 'Beschikbaarheid',
        inheritColorFromParentIfCustomNotSet:
            'Erf kleur van ouder als aangepaste niet ingesteld is',
        pickFromAllParts: 'Kies uit alle onderdelen',
        takeTool: 'Gereedschap nemen',
        returnTool: 'Gereedschap retourneren',
        personWhoTake: 'Persoon die neemt',
        personWhoReturn: 'Persoon die retourneert',
        takenAt: 'Opgenomen op',
        takenBy: 'Opgenomen door',
        toolIssuedBy: 'Gereedschap uitgegeven door',
        commentTake: 'Opmerking bij nemen',
        commentReturn: 'Opmerking bij retourneren',
        change: 'Veranderen',
        onlyWithActiveRMIssues: 'Alleen bij actieve RM-verzoeken',
        externalSystem: 'Extern systeem',
        rejectIssue: 'Probleem afwijzen',
        withdrawIssueRejection: 'Intrekken afwijzing probleem',
        rejectionReason: 'Reden van afwijzing',
        rejected: 'Afgewezen',
        showCrewMembers: 'Toon teamleden',
        crewMembers: 'Teamleden',
        helpGroup: 'Service',
        partsTakenByUser: 'Onderdelen opgenomen door gebruiker',
        pickParts: 'Onderdelen uitgeven',
        selectPersonWhoTakes: 'Selecteer persoon die neemt',
        changePersonWhoTakes: 'Verander persoon die neemt',
        quantityToPick: 'Hoeveelheid om op te halen',
        pickLocation: 'Opname locatie',
        selectPartsToPick: 'Selecteer onderdelen om op te halen',
        partSelected: 'Geselecteerd onderdeel',
        scanCodeOr: 'Scan code of',
        returnPart: 'Onderdeel retourneren',
        myTakenParts: 'Onderdelen opgenomen door mij',
        takenFromLocation: 'Opgenomen van locatie',
        takenQuantity: 'Opgenomen hoeveelheid',
        providedUnit: 'Aangeboden eenheid',
        providedQuantity: 'Aangeboden hoeveelheid',
        selectFromStorage: 'Selecteer uit opslag',
        selectFromMyPickedParts: 'Selecteer uit mijn opgehaalde onderdelen',
        exportProcessInProgressMessage:
            'Het exportproces van gegevens is zojuist gestart, zodra het is voltooid, ziet u een bijbehorende melding met een link naar het bestand.',
        yourDocumentIsReady: 'Uw document is klaar',
        rotateScreen: 'Draai scherm',
        addRule: 'Regel toevoegen',
        editRule: 'Regel bewerken',
        summary: 'Samenvatting',
        onlyAvailableEmployees: 'Toon alleen beschikbare werknemers',
        calculated_unit_price: 'Omgerekende eenheidsprijs',
        calculated_quantity: 'Omgerekende hoeveelheid',
        next: 'Nächste',
        maintenanceMode: 'Onderhoudsmodus',
        applicationMayBeUnavailableForFewMinutes:
            'Toepassing kan enkele minuten niet beschikbaar zijn',
        appWillRefreshIn: 'De toepassing wordt vernieuwd in',
        landscape: 'Landschap',
        portrait: 'Portret',
        orientation: 'Oriëntatie',
        format: 'Formaat',
        service: 'Bedienden',
        leader: 'Voormannen',
        defaultView: 'Standaardweergave',
        view: 'Kijk',
        oneDay: '1 dag',
        object: 'Object',
        finished: 'Klaar',
        onlyNotFinished: 'Alleen niet af',
        generate: 'Genereren',
        error: 'Fout',
        cell: 'Cel',
        resolutionSummary: 'Einde samenvatting',
        rejected_at: 'Afwijzingsdatum',
        rejected_by: 'Afgewezen door',
        finishedByUser: 'Afgemaakt door',
        formalConfirmByUser: 'Formele bevestiging door',
        formalConfirmAt: 'Datum van formele bevestiging',
        valueDeleted: '[Waarde verwijderd]',
        hasNotPlannedIssue: 'Heeft geen geplande problemen',
        showInStorage: 'In opslag laten zien',
        changeCode: 'Wijzig de code',
        staffProfiles: 'Werknemers profielen',
        profile: 'Profiel',
        user_bug: 'Applicatiefout',
        user_kaizen: 'Suggestie voor verandering',
        changeSuggestions: 'Suggesties wijzigen',
        showOnlyCurrentlyAvailable: 'Toon alleen momenteel beschikbaar',
        resetPassword: 'Herinner wachtwoord',
        forgotPassword: 'Wachtwoord vergeten',
        resetPasswordMailSent:
            'We hebben een link naar het opgegeven e-mailadres gestuurd om een ​​nieuw wachtwoord in te stellen',
        manyEventsThisTime: 'Veel evenementen in deze tijd',
        importScheduleCheckboxLabel:
            'Verwijder geplande gebeurtenissen in de geselecteerde maand voor werknemers die in het bestand staan ​​vermeld',
        inheritedEvent: 'Overgeërfde gebeurtenis',
        inheritedModifiedEvent: 'Gewijzigde overgeërfde gebeurtenis',
        equipmentId: 'Apparatuur ID',
        entryId: 'Invoer ID',
        partId: 'Onderdeel ID',
        suggestionsEmail:
            'E-mail waarnaar wijzigingssuggesties worden verzonden',
        meters: 'Tellers',
        scanCardToAuth:
            'Houd de kaart tegen de lezer of voer uw toegangscode in om uw identiteit te bevestigen',
        scanCard: 'Scan de kaart',
        cart: 'Uitwisselingsbox',
        emptyCardMessage:
            'Begin met het scannen van producten of selecteer ze uit de lijst om ze aan het winkelmandje toe te voegen.',
        terminalMode: 'eindtype',
        askPermittedUserToConfirmPartsExchange:
            'Vraag de geautoriseerde persoon om de vrijgave van het onderdeel te bevestigen door de kaart te scannen of de code in te voeren.',
        partsIssued: 'Onderdelen vrijgegeven',
        areYouSureAboutCancel: 'Weet je zeker dat je wilt annuleren?',
        areYouSureAboutRemoveFromCart:
            'Weet je zeker dat je dit item uit je winkelwagen wilt verwijderen?',
        standard: 'Standaard',
        idNumber: 'Identificatienummer',
        takeParts: 'Onderdelen nemen',
        returnParts: 'Onderdelen terugbrengen',
        quantityToReturn: 'Hoeveelheid om terug te brengen',
        partsPendingApproval: 'Onderdelen in afwachting van goedkeuring',
        partsReturned: 'Onderdelen teruggebracht',
        partsAddedToPendingApproval:
            'Onderdelen toegevoegd aan wachtende goedkeuring',
        approvePartsReturn: 'Keur onderdelenretour goed',
        partReturnApproved: 'Onderdeel retour goedgekeurd',
        partUsage: 'Onderdeelgebruik',
        awaitsReturn: 'Wacht op terugkeer',
        entrySelection: 'Selectie invoeren',
        correctQuantity: 'Hoeveelheid corrigeren',
        quantityCorrection: 'Hoeveelheidcorrectie',
        entrySelectionAsc: 'Selectie invoeren (oplopend)',
        entrySelectionDesc: 'Selectie invoeren (aflopend)',
        metersSettings: 'Meterinstellingen',
        countableFields: 'Aantal velden',
        equipmentTypes: 'Apparatuursoorten',
        fieldName: 'Veldnaam',
        countableField: 'Aantal veld',
        partsStatusTaken: 'Onderdelen genomen',
        rejectPartsReturn: 'Keur onderdelenretour af',
        areYouSureAboutRejectPartsReturn:
            'Weet je zeker dat je de onderdelenretour wilt afwijzen?',
        partReturnRejected: 'Onderdeel retour afgewezen',
        counterFields: 'Teller velden',
        counterName: 'Teller naam',
        counterFieldName: 'Teller veldnaam',
        counterId: 'Teller ID',
        counterUUID: 'Teller UUID',
        counterPickerPlaceholder: 'Selecteer een teller',
        pickFromPartsList: 'Kies uit onderdelenlijst',
        changeLocation: 'Verplaatsen',
        isPartStorageRoot: 'Onderdeel opslag root',
        isStorageRoot: 'Onderdeel opslag root',
        areYouSureAboutArchiveIssue:
            'Weet je zeker dat je de uitgifte wilt archiveren?',
        ganttChart: 'Gantt-diagram',
        table: 'Tafel',
        fittingEquipment: 'Passende apparatuur',
        notAssigned: 'Niet toegewezen',
        counters: 'Tellers',
        machineHourlyCostNotProvided: 'Uurloon van de machine niet opgegeven',
        eventTypesMightBeDefinedHere:
            'Evenementtypes kunnen hier worden gedefinieerd',
        toolsTakenByUser: 'Gereedschap genomen door gebruiker',
        predictedReturnDate: 'Voorspelde retourdatum',
        estimatedTimeOfUsingToolInHours:
            'Geschatte tijd om de tool te gebruiken (in uren)',
        showOnlyAvailable: 'Toon alleen beschikbaar',
        toolTakeLog: 'Tool Take Log',
        takeDate: 'Neem datum',
        returnDate: 'Retourdatum',
        personWhoAcceptReturn: 'Persoon die de retour accepteert',
        statisticStrategy: 'Bereikbaarheidsstrategie',
        EquipmentPlannedStrategy: 'Volgens het werkplan',
        EquipmentConstantAvailabilityStrategy: 'Altijd beschikbaar',
        actionAfterIssueFinish: 'Actie na uitgifte voltooid',
        enabled: 'Ingeschakeld',
        categoryOfNewIssue: 'Categorie van nieuwe uitgifte',
        workNotStarted: 'Werk niet begonnen',
        colorInherited: 'Kleur geërfd',
        abcClassification: 'ABC-classificatie',
        xyzClassification: 'XYZ-classificatie',
        classification: 'Classificatie',
        filters: 'Filters',
        wipeFilters: 'Filters wissen',
        takePartsFromUser: 'Neem onderdelen van gebruiker',
        selectPersonWhoReturns: 'Selecteer persoon die terugkeert',
        changePersonWhoReturns: 'Persoon die terugkeert wijzigen',
        returnLocation: 'Retourlocatie',
        returnQuantity: 'Retourhoeveelheid',
        globalSettings: 'Algemene instellingen',
        delimiter: 'Scheidingsteken',
        fieldRules: 'Veldregels',
        fieldValue: 'Veldwaarde',
        user_email_regex: 'Gebruiker e-mail regex',
        barcodeLength: 'Barcode lengte',
        partLine: 'Onderdeel lijn',
        partFamily: 'Onderdeel familie',
        partBatch: 'Onderdeel batch (batch)',
        testValueValid: 'Testwaarde geldig',
        testValueNotValid: 'Testwaarde niet geldig',
        canBePicked: 'Kan gekozen worden',
        issue_criticality: 'Problemen - kritiek',
        issue_help_webapp: 'Problemen - ondersteuning nodig (app)',
        issue_help_terminal: 'Problemen - ondersteuning nodig (Terminal)',
        issue_kind: 'Soort rapport',
        HIDE: 'Verbergen',
        SHOW: 'Show',
        REQUIRE: 'Vereisen',
        propagateValues: 'Waarde verspreiding',
        archived: 'Gearchiveerd',
        singleEvent: 'Eenmalige toegang',
        seriesOfEvents: 'Een reeks inzendingen',
        omitWeekends: 'Vermijd weekenden',
        allEntriesSaved: 'Alle vermeldingen zijn toegevoegd',
        parentCategory: 'Bovenliggende categorie',
        first_day_of_week: 'Eerste dag van de week',
        assignEmployee: 'Wijs een medewerker aan',
        addNewMachine: 'Voeg een nieuwe machine toe',
        addNewTool: 'Voeg een nieuw hulpmiddel toe',
        parentLocation: 'Ouderlocatie',
        equipmentStates: 'Apparatuurstatussen',
        equipmentState: 'Toestand van de uitrusting',
        fontColor: 'lettertype kleur',
        downtime: 'Downtime',
        setState: 'Staat instellen',
        from: 'van',
        to: 'naar',
        inProgress: 'bezig',
        noEntries: 'geen toegang',
        products: 'Producten',
        product: 'Product',
        setCurrentProduct: 'Stel het product in dat momenteel in productie is',
        commentable: 'Mogelijkheid tot commentaar',
        allows_state_update: 'Staatswijziging vereist tijdens commentaar',
        undescribed: 'Onbeschrijfelijk',
        state: 'Voorwaarde',
        productionMonitor: 'Productiemonitor',
        undescribedStates: 'Onbeschreven toestanden',
        toolsPicker: 'Gereedschap meenemen/retourneren',
        toolsGroups: 'Gereedschapsgroepen',
        of: 'van',
        image: 'Foto',
        selectTools: 'Kies gereedschap',
        takeTools: 'Hulpmiddelen downloaden',
        returnTools: 'Breng het gereedschap terug',
        askPermittedUserToConfirmToolsExchange:
            'Vraag de bevoegde persoon om de uitgifte/teruggave van het gereedschap te bevestigen door de kaart te scannen of de code in te voeren.',
        toolsPendingApproval:
            'Geretourneerde gereedschappen wachten op goedkeuring',
        production_monitor_visible_columns:
            'Productiemonitor - zichtbare kolommen',
        details: 'Details',
        otherData: 'Andere gegevens',
        showAllTools: 'Toon alle gereedschappen',
        allTools: 'Alle gereedschappen',
        approveToolReturn: 'Accepteer de retourzending van het gereedschap',
        rejectToolReturn: 'Weiger de retourzending van het gereedschap',
        areYouSureAboutRejectToolReturn:
            'Weet u zeker dat u de retourzending van het gereedschap wilt weigeren?',
        areYouSureAboutAcceptToolReturn:
            'Weet u zeker dat u de retourzending van het gereedschap wilt bevestigen?',
        toolReturnApproved: 'Teruggave van gereedschap goedgekeurd',
        toolReturnRejected: 'Retour gereedschap afgewezen',
        toReturn: 'Terugbrengen',
        toolsCart: 'Ruildoos - gereedschap',
        toolsIssued: "Hulpprogramma's gedownload",
        toolsAddedToPendingApproval:
            'De tools zijn toegevoegd aan de wachtlijst voor goedkeuring van de retourzending',
        toolsReturned: 'Gereedschap terug',
        mainShift: 'Belangrijkste verschuiving',
        scanCode: 'Scan de code',
        codeRecognized: 'Code herkend',
        moveAllEntriesFromCurrentLocation:
            'Verplaats alle vermeldingen vanaf deze locatie',
        newAwaitingValue: 'Nieuwe waarde wacht op goedkeuring',
        newValuesArePendingConfirmation:
            'De wijzigingen wachten op goedkeuring',
        changeRequests: 'Verander verzoeken',
        currentValues: 'Huidige waarden',
        requestedValues: 'Waarden om te veranderen',
        removeRequestIsWaitingForApprove:
            'De verwijdering wacht op goedkeuring',
        imageRemoveRequestLabel: 'Een foto verwijderen',
        areYouSureAboutCancelChangeRequest:
            'Weet u zeker dat u het wijzigingsverzoek wilt annuleren?',
        document: 'Document',
        rename: 'Hernoemen',
        openInEditor: 'Openen in editor',
        unsavedChangesMayBeLost:
            'Niet-opgeslagen wijzigingen kunnen verloren gaan',
        location_name_regex: 'Regel voor locatienaam',
        employeesWorkingCount:
            'Aantal medewerkers dat zich met dit onderwerp bezighoudt',
        always: 'Altijd',
        indexes: 'Indexen',
        indexesEntriesTypes: 'Invoertypen',
        indexEntry: 'Invoertypen',
        index: 'Inhoudsopgave',
        pickIndex: 'Selecteer een index',
        report: 'Rapport',
        reportGenerationInProgress: 'Het rapport genereert',
        production_monitor_equipment_state_change:
            'Het wijzigen van de machinestatus vanaf de productiemonitor',
        part_entries_auto_barcode_generation:
            'Automatisch barcodes genereren voor onderdeelinvoer',
        new_issue_equipment_kind: 'Type apparatuur in de nieuwe kennisgeving',
        manageVisibleColumns: 'Pas de zichtbaarheid van kolommen aan',
        columnName: 'Kolomnaam',
        visible: 'Zichtbaar',
        partStorageRootWarningMessage:
            'Deze locatie wordt ingesteld als de hoofdlocatie van het onderdelenmagazijn. In het magazijn en het selectievenster voor de magazijnlocatie kunt u alleen items selecteren die zich op deze locatie bevinden',
        entriesLocation: 'inzendingen locatie',
        cloneIssue: 'Kloon',
        machinesMap: 'Machinekaart',
        doYouWantToAddNewMarker: 'Wilt u hier een nieuwe tag toevoegen?',
        areYouSureAboutRemoveMarker:
            'Weet u zeker dat u deze tag wilt verwijderen?',
        plants: 'Fabrieksinstallaties',
        plant: 'Fabriek',
        buildings: 'Gebouwen',
        building: 'Gebouw',
        floors: 'Vloeren',
        floor: 'Vloer',
        map: 'Kaart',
        areYouSureAboutMoveMarker:
            'Weet u zeker dat u deze markering wilt verplaatsen?',
        marker: 'Markeerstift',
        addNewMarkerTooltipMessage:
            'Om een ​​nieuwe markering toe te voegen, klikt u met de rechtermuisknop op de kaart.',
        takenTools: 'Vrijgegeven gereedschappen',
        askPermittedUserToConfirmToolExchange:
            'Vraag de bevoegde persoon om de uitgifte/retournering van het gereedschap te bevestigen door de kaart te scannen of de code in te voeren.',
        warnDays: 'Waarschuwing vóór vervaldatum (dagen)',
        licenseType: 'Licentie type',
        licenseGroup: 'Licentiegroep',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Bevestiging / afwijzing vereisen bij teruggave van gedownloade tools',
        attachments: 'Bijlagen',
        attachment: 'Bijlage',
        searchInCurrentLocation: 'Zoek op uw huidige locatie',
        icon: 'Icoon',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'Ander',
        tags: 'Kaarten/ Tags',
        tag: 'Kaart / Tag',
        userPinCode: 'Pincode van kaartgebruiker',
        pin_code_field_type: 'Type pincode',
        alphanumeric: 'Alfanumeriek',
        numeric: 'Numeriek',
        showCodeOwnerNameDuringParing:
            'Toon de naam van de code-eigenaar bij het koppelen met een kaart/tag',
        showUsernameInCart: 'Toon gebruikersnaam in winkelwagen',
        flag: 'Vlag',
        flags: 'Vlaggen',
        manageFlags: 'Beheer vlaggen',
        skills: 'Vaardigheden',
        skill: 'Vaardigheid',
        skillRank: 'Beoordeling',
        selectToolsByType: 'Selecteer gereedschap op type',
        openToolsPickerOnCartInit:
            'Open automatisch het gereedschapselectievenster wanneer u naar de winkelwagen gaat.',
        toolsTypes: 'Soorten gereedschap',
        workOrderTemplates: 'Sjablonen voor werkorders',
        workOrderTemplate: 'Werkordersjabloon',
        workOrders: 'Werkorders',
        workOrder: 'Werkorder',
        employee: 'Medewerker',
        workOrderCreatedBy: 'In opdracht van',
        print: 'Afdrukken',
        issueCreated: 'Er is een ticket aangemaakt',
        newIssue: 'Nieuw rapport',
        sampleButtonPlaceholder: 'Voorbeeldknop',
        preferences: 'Voorkeuren',
        buttonsSize: 'Knoopgrootte',
        defaultValue: 'Standaardwaarde',
        warning: 'Waarschuwing',
        allowedIssuesCategories: 'Toegestane probleemcategorieën',
        hideAbilityToAssignEmployeesToIssue:
            'Verberg de mogelijkheid om medewerkers aan een probleem toe te wijzen',
        issuesWithRelatedCategories: 'Voeg subcategorieën toe',
        issuesLimit: 'Beperking van problemen',
        issuesLimits: 'Problemen - limieten',
        closeLocker: 'Sluit de kast',
        closeLockerMessage: 'Sluit de kast om door te gaan',
        closedTooFast: 'Ben je te snel gesloten?',
        doYouWantToReopenLocker: 'Wilt u de locker weer openen?',
        reopen: 'Heropenen',
        quit: 'Finish',
        hiddenFields: 'Verborgen velden',
        defaultValues: 'Standaard waarden',
        paddingBottom: 'Lege ruimte onderaan',
        allVisibleFieldsRequired:
            'Vereisen dat alle zichtbare velden zijn ingevuld',
        emailConfirmation: 'Bevestiging van e-mailadres',
        user_active_after_email_confirm:
            'Gebruikersaccount wordt automatisch geactiveerd na bevestiging van uw e-mailadres',
        phone_change_requires_confirmation_code:
            'Het wijzigen van het telefoonnummer vereist bevestiging met een code',
        toolsLocation: 'Locatie van het gereedschap',
        manageFilters: 'Beheer filters',
        erase: 'wissen',
        can_pick_undescribed_equipment_state:
            'Mogelijkheid om een ​​onbeschrijfelijke staat te kiezen',
        helpdesk: 'Helpdesk',
        measureTypes: 'Soorten metingen',
        measureType: 'Metingstype',
        measurable: 'Meetbare indicator',
        measurables: 'Meetbare indicatoren',
        measurements: 'Meting',
        measurement: 'Meting',
        measuredAt: 'Meetdatum',
        employeeNumber: 'Werknemersnummer',
        lastLocation: 'Laatste locatie',
        readonly: 'Alleen lezen',
        equipment: 'Apparatuur',
        conditions: 'Voorwaarden',
        permission: 'Toestemming',
        formula: 'Formule',
        notification: 'Kennisgeving',
        transition: 'Overgang',
        fillValuesToChangeState: 'Vul de waarden in om de status te wijzigen.',
        loginTo: 'Inloggen',
        appName: 'Signalo CMMS',
        manageState: 'Beheer staat',
        webMessage: 'Webbericht',
        terminalId: 'Terminal-ID',
        operatorId: 'Operator-ID',
        newConversation: 'Nieuwe draad',
        application: 'App',
        phones: 'Telefoonnummers',
        message: 'Bericht',
        channels: 'Kanalen',
        url: 'URL',
        kind: 'Vriendelijk',
        forkfleetConfigId: 'Forkfleet Configuratie',
        create: 'Creëren',
        terminate: 'Beëindigen',
        recreateIssue: 'Maak het ticket opnieuw aan',
        ordinal: 'Ordinale waarde',
        parameterName: 'Parameternaam',
        backgroundColor: 'Achtergrond kleur',
        columns: 'Aantal columns',
        colspan: 'Breedte (kolommen)',
        fill: 'Compleet',
        duplicate: 'Duplicaat',
        loginAsThisUser: 'Log in als deze gebruiker',
        partLot: 'Serie',
        minBrowserVersion: 'Minimale browserversie vereist',
        currentVersion: 'Huidige versie',
        equipment_planned_completed_percent_target:
            'Percentagedoelstelling voor de uitvoering van geplande inspecties',
        autoTranslate: 'Automatische vertaling',
        auto_translation: 'Automatische vertaling',
        awaitingAutoTranslation: 'Wachten op automatische vertaling',
        signaturePinTagConfirmationText1: 'Bordje met @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'of scan uw kaart.',
        signedWithPinCode: 'Gesigneerd met @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Gesigneerd met kaart/tag',
        trusted_device_code_login_users_limit:
            'Snel inloggen - aantal weergegeven gebruikers',
        display_fields_issue_created_at: 'Velden weergeven - Rapport aanmaken',
        docs_sidebar_hidden_by_default: 'Documenten - verbergen van de zijbalk',
        issue: 'Melding',
        control: 'Controle',
        compatibility: 'Compatibiliteit',
        replacement: 'Vervanging',
        backCompatibility: 'Bidirectionele compatibiliteit',
    },
    placeholders: {
        part: 'Selecteer onderdeel...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefoonnummer...',
        password: 'Wachtwoord...',
        password_confirmation: 'Bevestig wachtwoord...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Niet uw account?',
    },
    signup: {
        registered: 'Succes!',
        emailConfirmed: 'De e-mail is bevestigd.',
        registered_info: 'Vraag uw supervisor om uw account te activeren',
        confirmEmailAddress:
            'Il tuo account è stato creato, fai clic sul collegamento nell`e-mail per confermare il tuo indirizzo.',
        tokenNotFoundError:
            'De e-mail is al bevestigd of de bevestigingslink is ongeldig.',
    },
    paramTypes: {
        text: 'Tekst',
        note: 'Notitie',
        integer: 'Geheel getal',
        decimal: 'Decimaal',
        date: 'Datum',
        time: 'Uur',
        datetime: 'Datum en uur',
        color: 'Kleur',
        icon: 'Icoon',
        boolean: 'Nee / Ja',
        signature: 'Handtekening',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Naam',
        path: 'Pad naar bestand',
        category: 'Categorie',
        equipment: 'Uitrusting',
        criticality: 'Kritiek',
        status: 'Status',
        created: 'Gemaakt',
        createdBy: 'Gemaakt door',
        fp: 'FP',
        type: 'Type',
        designation: 'Benaming',
        symbol: 'Symbool',
        serialNumber: 'Serienummer',
        registryNumber: 'Registratienummer',
        udtNumber: 'UDT-nummer',
        manufacturedYear: 'Fabricagejaar',
        actions: 'Acties',
        title: 'Titel',
        data: 'Datum',
        archived: 'Gearchiveerd',
        manufacturerSymbol: 'Fabrikantsymbool',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Hoeveelheid',
        priority: 'Prioriteit',
        price: 'Prijs',
        kind: 'Soort',
        description: 'Beschrijving',
        default: 'Standaard',
        warning: 'Waarschuwing',
        problem: 'Probleem',
        fixing: 'Herstel',
        changeOrder: 'Verander bestelling',
        required: 'Vereist',
        icon: 'Icoon',
        color: 'Kleur',
        subCategories: 'Subcategorieën',
        barCode: 'Barcode',
        subLocations: 'Sublocaties',
        categories: 'Categorieën',
        image: 'Afbeelding',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'E-mail',
        phone: 'Telefoonnummer',
        function: 'Functie',
        department: 'Afdeling',
        accountStatus: 'Accountstatus',
        shift: 'Dienst',
        licenseNumber: 'Rijbewijsnummer',
        issuedDate: 'Uitgiftedatum',
        expiresDate: 'Vervaldatum',
        entries: 'Invoeren',
        entryNumber: 'Invoernummer',
        buyPrice: 'Inkoopprijs',
        currentLocationQuantity: 'Hoeveelheid op huidige locatie',
        group: 'Groep',
        string: 'Tekst',
        integer: 'Geheel getal',
        toolsGroup: 'Gereedschapsgroep',
        manufacturer: 'Fabrikant',
        shortName: 'Korte naam',
        locationName: 'Locatienaam',
        subLocationsQuantity: 'Hoeveelheid sublocaties',
        isWorkingOnIssue: 'Werkt aan kwestie',
        openIssues: 'Open kwesties',
        notificationDate: 'Meldingsdatum',
        titleAndDescription: 'Titel en beschrijving',
        read: 'Gelezen',
        created_at: 'Gemaakt',
        received_at: 'Ontvangen',
        started_at: 'Begon',
        arrived_at: 'Aangek',
        finished_at: 'Afgerond',
        country: 'Land',
        city: 'Stad',
        progress: 'Voortgang',
    },
    searchConfig: {
        id: 'Id',
        name: 'Naam...',
        shortName: 'Korte naam...',
        country: 'Land...',
        email: 'E-mail...',
        group: 'Groep...',
        planned: 'Gepland',
        category: 'Categorie...',
        object: 'Object...',
        criticality: 'Kritiek',
        fp: 'FP',
        type: 'Type...',
        designation: 'Aanduiding...',
        symbol: 'Symbool...',
        serialNumber: 'Serienummer...',
        registryNumber: 'Registernummer...',
        udtNumber: 'UDT-nummer...',
        manufacturedYear: 'Fabrieksjaar...',
        manufacturerSymbol: 'Fabrikantssymbool...',
        priority: 'Prioriteit...',
        quantity: 'Aantal...',
        buyPrice: 'Inkoop prijs...',
        kind: 'Soort...',
        toolsGroup: 'Gereedschapsgroep...',
        function: 'Functie...',
        department: 'Afdeling...',
        status: 'Status...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefoon...',
        barCode: 'Barcode',
        color: 'Kleur...',
        icon: 'Icoon...',
        machine: 'Machine...',
        tool: 'Gereedschap...',
        urgentAndOutdated: 'Urgent en verouderd',
        urgent: 'Urgent',
        expired: 'Verlopen',
        manufacturer: 'Fabrikant',
    },
    errors: {
        error: 'Er is een fout opgetreden',
        wrongEmail: 'Ongeldig e-mailadres',
        wrongPasswordLength: 'Wachtwoord moet minimaal 8 tekens lang zijn.',
        wrongCodeLength: 'Code moet minimaal 5 tekens lang zijn.',
        passwordsNotMatch: 'Wachtwoorden komen niet overeen',
        codesNotMatch: 'Codes komen niet overeen',
        codeAlreadyInUse: 'Code is al in gebruik',
        expiresDateLowerThanIssued:
            'Vervaldatum kan niet lager zijn dan uitgiftedatum.',
        cannotMoveToTheSameLocation:
            'Kan niet naar dezelfde locatie verplaatsen.',
        locationRequired: 'Locatie is vereist.',
        putQuantity: 'Voer hoeveelheid in om te scheiden.',
        valueGreaterThanQuantity: 'Waarde is groter dan totale hoeveelheid.',
        wholeCannotBeDistinguished: 'Geheel kan niet worden onderscheiden.',
        yearMustBeGreaterThan: 'Jaar moet groter zijn dan ',
        passwordConfirmationNotMatch: 'Wachtwoorden komen niet overeen',
        mustBeInteger: 'Waarde moet een geheel getal zijn',
        valueTooLong: 'Waarde is te lang',
        wrongPhoneNumber: 'Onjuist telefoonnummer',
        phoneNumberAlreadyTaken: 'Telefoonnummer is al in gebruik',
        emailAlreadyTaken: 'E-mailadres is al in gebruik',
        notFound: 'Niet gevonden',
        sessionExpired: 'Sessie is verlopen',
        tenantNotFound:
            'De aangegeven configuratie bestaat niet. Controleer het siteadres en probeer het opnieuw.',
        selectEquipmentTypeToConfigureParameters:
            'Selecteer het type uitrusting om parameters te configureren.',
        noParametersToConfigure:
            'Het geselecteerde uitrustingstype heeft geen parameters om te configureren.',
        terminalAlreadyRegistered: 'Terminal is al geregistreerd.',
        invalidPin: 'Ongeldige PIN',
        eventCollision:
            'De tijd van het evenement dat u wilt toevoegen overlapt de tijd van een ander evenement.',
        mustStartWithSlash: 'Moet beginnen met /',
        mustBeBetween: 'Waarde moet liggen tussen:',
        minLength: 'Minimale lengte: ',
        maxLength: 'Maximale lengte: ',
        invalidInputForCodeType: 'Ongeldige invoer voor geselecteerde codetype',
        invalidCodeOrNoPermission:
            'De code is ongeldig of u heeft niet voldoende rechten om deze actie uit te voeren.',
        endDateLowerThanStart: 'Einddatum mag niet lager zijn dan startdatum',
        iconAlreadyTaken: 'Icoon is al in gebruik',
        notEnoughQuantityInStorage: 'Onvoldoende hoeveelheid in opslag',
        valueTooLow: 'Waarde te laag',
        valueTooHigh: 'Waarde te hoog',
        maxAvailableQuantity: 'Maximum aantal',
        someFilesRejectedDueToSize:
            'Sommige bestanden werden geweigerd vanwege de grootte. Maximale grootte van een enkel bestand:',
        cameraDeviceNotFound: 'Camera-apparaat niet gevonden',
        cameraPermissionDenied:
            'De toegang tot de apparaatcamera is geblokkeerd in de site-instellingen, reset de site-instellingen en sta het gebruik van de camera toe.',
        passwordResetLinkExpired:
            'De link voor het opnieuw instellen van het wachtwoord is verlopen',
        noInternetConnection: 'Geen internet verbinding',
        minimum: 'Minimum',
        mustBeGreaterThan: 'Moet groter zijn dan',
        noEventTypesDefined: 'Geen gebeurtenistypen gedefinieerd',
        regexPatternDelimiterError:
            'Het scheidingsteken moet worden weggelaten met het teken \\ bijvoorbeeld: \\/',
        emailNotMatchPatternDefiniedInTenant:
            'E-mailadres komt niet overeen met het patroon gedefinieerd in de configuratie',
        partMustHaveEntriesToCorrectQuantity:
            'Het onderdeel moet vermeldingen hebben om de hoeveelheid te corrigeren.',
        fileTooBigToOpenWillBeDownloaded:
            'Het bestand is te groot om te openen, het bestand wordt naar uw apparaat gedownload.',
        entriesNotSavedDueToCollision:
            'Inzendingen zijn niet toegevoegd. Er bestaan ​​al evenementen op het geselecteerde tijdstip.',
        someEntriesWereRejected:
            'Sommige vermeldingen zijn niet toegevoegd omdat ze conflicteren met andere evenementen.',
        toolAlreadyInCart: 'Dit hulpmiddel bevindt zich al in uw winkelwagen',
        toolAlreadyTaken: 'Deze tool is al uitgebracht',
        toolIsNotTaken: 'Dit hulpmiddel is nog niet vrijgegeven',
        documentNotEditable: 'Dit document kan niet worden bewerkt',
        notPermissionsToEditDocument:
            'U heeft geen toestemming om dit document te bewerken',
        cannotLoadDocumentNoPath:
            'Het document kon niet worden geladen - ongeldig adres',
        locationNameNotMatchPatternDefiniedInTenant:
            'De naam komt niet overeen met de regel die is gedefinieerd in de instellingen',
        noFloorLayoutProvided: 'De verdieping heeft geen gedefinieerde kaart',
        maximum: 'Maximale waarde',
        allLanguagesRequired: 'Vul de waarde in alle talen in',
        noItemsAvailable: 'Geen artikelen beschikbaar',
        noFlagsConfigured: 'Geen vlaggen gedefinieerd',
        noSkillsDefined: 'Geen vaardigheid gedefinieerd',
        someoneIsWorkingOnIssue:
            'Niet alle medewerkers hebben hun werk aan dit rapport voltooid. Weet je zeker dat je het wilt beëindigen?',
        fillAllRequiredParameters: 'Vul alle vereiste parameters in.',
        issueLimitError:
            'De limiet van problemen in de geselecteerde categorie is bereikt: ',
        issueLimitError2: 'en functie: ',
        duplicateError: 'Deze waarde bestaat al',
        versionErrorMessage:
            'Uw recente wijzigingen zijn niet opgeslagen omdat iemand anders tegelijkertijd wijzigingen heeft aangebracht. Vernieuw de pagina en probeer het opnieuw.',
        firstLoginTrustedDeviceError:
            'De eerste keer dat u op een nieuw apparaat inlogt, zijn uw e-mailadres en wachtwoord vereist.',
        tagNotFound: 'Kaart/tag niet herkend',
        noChecklistsAssignedToControl:
            'Aan de geselecteerde controle is geen checklist toegewezen',
        lockerNotConnected: 'Slot is niet verbonden',
        lockerNotAvailable: 'Slot is niet beschikbaar',
        noChecklistItemsError: 'Checklist is niet geconfigureerd',
    },
    navDrawer: {
        dashboard: 'Dashboard',
        issues: 'Problemen',
        timetable: 'Rooster',
        machines: 'Machines',
        tools: 'Gereedschappen',
        parts: 'Onderdelen',
        storage: 'Magazijn',
        staff: 'Personeel',
        configuration: 'Configuratie',
        notes: 'Notities',
        notifications: 'Meldingen',
        profile: 'Profiel',
        supervision: 'Toezicht',
    },
    barcodeScanner: {
        barCode: 'Barcode',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Categorie...',
        selectCategory: 'Selecteer categorie',
        noSubcategories: 'Geen subcategorieën',
    },
    companies: {
        addCompany: 'Bedrijf toevoegen',
        editCompany: 'Bedrijf bewerken',
        fullName: 'Volledige naam',
        shortName: 'Afkorting',
        group: 'Groep',
        country: 'Land',
        city: 'Stad',
        street: 'Straat',
        postCode: 'Postcode',
        phone: 'Telefoon',
        email: 'E-mail',
        website: 'Website',
        NIP: 'NIP',
        REGON: 'Nationale Bedrijfsregistratie',
        active: 'Actief',
        nameRequired: 'Naam is verplicht',
        shortNameRequired: 'Afkorting is verplicht',
    },
    issues: {
        tookAt: 'Genomen om',
        changeHistory: 'Wijzigingsgeschiedenis',
        load: 'Laden',
        date: 'Datum',
        createdBy: 'Aangemaakt door',
        action: 'Actie',
        data: 'Gegevens',
        created: 'Aangemaakt',
        updated: 'Bijgewerkt',
        deleted: 'Verwijderd',
        restored: 'Hersteld',
        issues: 'Problemen',
        issue: 'Probleem',
        by: 'door',
        name: 'Naam',
        applicantsDescription: 'Omschrijving aanvrager',
        accidentDescription: 'Omschrijving ongeval',
        jobDescription: 'Omschrijving werkzaamheden',
        jobSummary: 'Samenvatting werkzaamheden',
        category: 'Categorie',
        status: 'Status',
        noFlow: '[Geen stroom]',
        equipment: 'Uitrusting',
        criticality: 'Kritiek',
        hour: 'Uur',
        formalConfirmation: 'Formele bevestiging',
        formalConfirmationShortcut: 'FB',
        formalConfirmationRequired: 'FB vereist',
        parameter: 'Parameter',
        value: 'Waarde',
        addIssue: 'Probleem toevoegen',
        expectedCompletionDate: 'Verwachte voltooiingsdatum',
        issueDescription: 'Probleemomschrijving',
        partsUsage: 'Verwerking onderdelen',
        assignedEmployees: 'Toegewezen medewerkers',
        requiredHelp: 'Benodigde hulp',
        returnParts: 'Onderdeel retourneren',
        confirmUnassignEmployeeWhoTakenIssue:
            'Deze medewerker heeft het geselecteerde probleem opgepakt. Wilt u hem verwijderen?',
        responsibleUser: 'Verantwoordelijke gebruiker',
        responsibleRules: 'Verantwoordelijke gebruikers - regels',
    },
    machines: {
        machines: 'Machines',
        xIssuesNotPlanned: ' (niet gepland)',
        noIssues: 'Geen problemen',
    },
    maintenance: {
        maintenance: 'Onderhoud',
    },
    notes: {
        notes: 'Notities',
        note: 'Notitie',
        title: 'Titel',
        archived: 'Gearchiveerd',
    },
    parts: {
        parts: 'Onderdelen',
        warehouseOutgoings: 'Magazijnuitgangen',
        fittingEquipmentTypes: 'Passende apparatuurtypes',
        goToEquipmentType: 'Ga naar apparatuurtype',
        selectPart: 'Selecteer onderdeel',
        usageReason: 'Reden',
        usageOtherReason: 'Anders',
        replacements: 'Vervangingen',
        partEntry: 'Onderdeel-invoer',
        goToPart: 'Ga naar onderdeel',
        fittingMachines: 'Passende machines',
    },
    costCenter: {
        costCenter: 'Kostencentrum',
    },
    equipmentTypes: {
        equipment: 'Uitrusting',
        newEquipmentType: 'Nieuw apparatuurtype',
        fittingParts: 'Passende onderdelen',
        goToParts: 'Ga naar onderdeel',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Definities machines en gereedschappen',
    },
    flows: {
        flow: 'Stroom',
        states: 'Staten',
        transitions: 'Overgangen',
        state: 'Staat',
        default: 'Standaard',
        warning: 'Waarschuwing',
        problem: 'Probleem',
        fixing: 'Repareren',
        finished: 'Afgerond',
    },
    parameters: {
        categoryParameter: 'Categorieparameter',
        equipmentTypeParameter: 'Apparatuurtypeparameter',
    },
    staff: {
        staff: 'Personeel',
        editUserAccess: 'Bewerk gebruikerstoegang',
        permissionsUpdated: 'Permissies bijgewerkt',
        passwordUpdated: 'Wachtwoord bijgewerkt',
        codeUpdated: 'Code bijgewerkt',
        changePasswordAndCode: 'Wijzig wachtwoord en code',
        goToLicenses: 'Ga naar licenties',
        editAccess: 'Bewerk toegang',
        editUser: 'Bewerk gebruiker',
        addUser: 'Voeg nieuwe gebruiker toe',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Accountstatus',
        phoneNumber: 'Telefoonnummer',
        department: 'Afdeling',
        passwordChange: 'Wachtwoord wijzigen',
        codeChange: 'Code wijzigen',
        newPassword: 'Nieuw wachtwoord',
        confirmNewPassword: 'Bevestig nieuw wachtwoord',
        changePassword: 'Wijzig wachtwoord',
        newCode: 'Nieuwe code',
        confirmNewCode: 'Bevestig nieuwe code',
        changeCode: 'Wijzig code',
        addEntry: 'Voeg invoer toe',
        editEntry: 'Bewerk invoer',
        editLicense: 'Bewerk licentie',
        addLicense: 'Voeg licentie toe',
        licenseNumber: 'Licentienummer',
        prefferedLocale: 'Voorkeurstaal',
        oldPassword: 'Oud wachtwoord',
        newPasswordConfirmation: 'Bevestig nieuw wachtwoord',
        reading: 'Weergave',
        creating: 'Aanmaken',
        updating: 'Bijwerken',
        deleting: 'Verwijderen',
        importScheduleFile: 'Importeer een schema uit een bestand',
        importSchedule: {
            errors: {
                user_not_found: 'Gebruiker niet gevonden [{user}]',
                user_found_many: '{count} gebruikers gevonden [{user}]',
                event_collision: 'Botsing van gebeurtenissen',
                hour_cell_parse: 'Fout bij het parseren van cellen',
            },
        },
        oldCode: 'Oude code',
        newCodeConfirmation: 'Bevestiging van de nieuwe code',
        setAccessBasedOnProfile: 'Toegang verlenen op basis van profiel',
        selectAccessMergeType: 'Kies hoe u machtigingen wilt combineren',
        noAccessesInProfileMessage:
            'Het geselecteerde profiel heeft geen rechten. Wilt u toch overschrijven?',
    },
    breadCrumb: {
        configuration: 'Configuratie',
        locations: 'Locaties',
        home: 'Startpagina',
        machines: 'Machines',
        tools: 'Gereedschappen',
        issues: 'Problemen',
        notes: 'Notities',
        maintenance: 'Onderhoud',
        parts: 'Onderdelen',
        warehouse: 'Magazijn',
        dictionary: 'Woordenboek',
        categories: 'Categorieën',
        parameters: 'Parameters',
        costCenter: 'Kostencentrum',
        flows: 'Stromen',
        states: 'Staten',
        transitions: 'Overgangen',
        shiftSchemas: "Dienstroosterschema's",
        shifts: 'Diensten',
        definitionsOfMachinesAndToolsTypes:
            'Definities machines en gereedschappen types',
        add: 'Toevoegen',
        edit: 'Bewerken',
        staff: 'Personeel',
        licenses: 'Licenties',
        entries: 'Invoeren',
        companiesDatabase: 'Bedrijfsdatabank',
        companyManagement: 'Bedrijfsbeheer',
        companyData: 'Bedrijfsgegevens',
        supportedLanguages: 'Ondersteunde talen',
        en: 'Engels',
        pl: 'Pools',
        es: 'Spaans',
        de: 'Duits',
        defaultLanguage: 'Standaardtaal',
        notifications: 'Meldingen',
        notificationsManagement: 'Meldingenbeheer',
        myProfile: 'Mijn profiel',
    },
    attributeTypes: {
        text: 'Tekst',
        note: 'Notitie',
        integer: 'Geheel getal',
        decimal: 'Decimaal',
        date: 'Datum',
        time: 'Tijd',
        dateTime: 'Datum en tijd',
        color: 'Kleur',
        icon: 'Icoon',
        boolean: 'Ja/Nee',
    },
    costCalculator: {
        costCalculator: 'Kostencalculator',
        waitTime: 'Wachttijd',
        serviceTime: 'Servicetijd',
        suspendTime: 'Onderbrekentijd',
        totalTime: 'Totale tijd',
        estimatedCost: 'Geschatte kosten',
        calculate: 'Berekenen',
        withoutParts: 'Zonder onderdelen',
        timeOfReportingIssue: 'Tijd van melding van probleem',
        timeOfServiceStart: 'Tijd van start service',
        timeOfReportingEnd: 'Tijd van einde service',
        days: 'Dagen',
        hours: 'Uren',
        minutes: 'Minuten',
        enterNewTime: 'Voer nieuwe tijd in',
        fromIssueReportToServiceStart:
            'Tijd van melding van probleem tot start service',
        workTime: 'Werktijd',
        includeAwaitingTime: 'Inclusief wachttijd',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Mijn problemen',
                assignedToMe: 'Aan mij toegewezen',
                assignedToGroup: 'Aan mijn groep toegewezen',
                tookByMe: 'Door mij genomen',
                takeIssueBtn: 'Nemen',
                arriveIssueBtn: 'Ik ben gearriveerd',
                finishIssueBtn: 'Voltooid',
                history: 'Geschiedenis',
                myResponsible: 'Ik ben verantwoordelijk voor',
            },
        },
    },
    synchronization: {
        enabled: 'Ingeschakeld',
        hasHeaders: 'Hebben koppen',
        leaveFile: 'Bestand achterlaten',
        host: 'Host',
        port: 'Poort',
        protocol: 'Protocol',
        username: 'Gebruikersnaam',
        password: 'Wachtwoord',
        root: 'Root',
        encoding: 'Encoding',
        separator: 'Scheidingsteken',
        externalSystemId: 'Extern systeem ID',
        cronExpression: 'Cron-uitdrukking',
        appendFullStock: 'Volledige voorraad toevoegen',
        includeHeaders: 'Koppen opnemen',
        withTrashed: 'Met verwijderde gegevens',
        filePattern: 'Bestandspatroon',
    },
    processes: {
        created_at: 'Aangemaakt op',
        started_at: 'Begonnen op',
        updated_at: 'Bijgewerkt op',
        finished_at: 'Afgerond op',
        attempts: 'Pogingen',
        queue: 'Wachtrij',
        job_id: 'Taak-ID',
        job_uuid: 'Taak-UUID',
        progress_max: 'Maximale voortgang',
        progress_now: 'Huidige voortgang',
        outputMessage: 'Uitvoerbericht',
        status: {
            queued: 'in wachtrij',
            executing: 'uitvoerend',
            finished: 'afgerond',
            failed: 'mislukt',
            retrying: 'opnieuw proberen',
            undefined: 'niet gedefinieerd',
        },
    },
    weekDays: {
        mo: 'Maandag',
        tu: 'Dinsdag',
        we: 'Woensdag',
        th: 'Donderdag',
        fr: 'Vrijdag',
        sa: 'Zaterdag',
        su: 'Zondag',
    },
    reports: {
        reports: 'Rapporten',
        dateFrom: 'Datum vanaf',
        dateTo: 'Datum tot',
        types: {
            operation_sheet: 'Werkblad',
            issue_summary: 'Samenvatting van het probleem',
            grouped_summary: 'Samenvattingsverslag',
            storage_operations: 'Magazijnwerkzaamheden',
            part_quantity_export: 'Aantal onderdelen',
        },
        reportFor: 'Verslag voor',
        includeQuantityLeft0: 'Voeg onderdelen met een nulhoeveelheid toe',
    },
    logs: {
        issues: {
            escalation: 'Escalatie ({minutes} min) - notificatie verzonden',
        },
        issueEmployee: {
            assignedAt: 'Medewerker toegewezen:',
            receivedAt: 'Medewerker heeft ontvangen:',
            tookAt: 'Medewerker heeft overgenomen:',
            finishedAt: 'Medewerker heeft voltooid:',
            deletedAt: 'Medewerker verwijderd uit de melding',
        },
    },
    units: {
        no: 'Deel',
        st: 'Set',
    },
    rrule: {
        frequency: 'Frequentie',
        dtstart: 'Begin datum',
        tzid: 'Tijdzone',
        until: 'Tot',
        count: 'Graaf',
        interval: 'Interval',
        wkst: 'Start dag',
        byweekday: 'doordeweeks',
        bymonth: 'Bij maand',
        yearly: 'Jaarlijks',
        monthly: 'Maandelijks',
        weekly: 'Wekelijks',
        daily: 'Dagelijks',
        hourly: 'per uur',
        minutely: 'Minutieus',
        secondly: 'ten tweede',
        infinitePeriodicityMessage:
            'De periodiciteit is oneindig, vanwege de prestaties worden slechts 500 rijen weergegeven',
    },
    months: {
        jan: 'Januari',
        feb: 'Februari',
        mar: 'Maart',
        apr: 'April',
        may: 'Kunnen',
        jun: 'Juni',
        jul: 'Juli',
        aug: 'Augustus',
        sep: 'September',
        oct: 'Oktober',
        nov: 'November',
        dec: 'December',
    },
    charts: {
        charts: 'Grafieken',
        count: 'Aantal nummers',
        total: 'Totale uitgiftetijd (van rapport tot afwerking)',
        serw: 'Totale reparatietijd (Ttotal - Twait)',
        mttr1: 'Gemiddelde tijd van rapport tot finish',
        mttr2: 'Gemiddelde tijd van opname tot finish',
        mtbf: 'Gemiddelde uptime tussen problemen',
        mttf: 'Gemiddelde tijd tot de fout',
    },
    accessMergeValues: {
        sum: 'Som',
        product: 'Product',
        overwrite: 'Overschrijven',
    },
    tpm: {
        history: 'Geschiedenis',
        standardObstacle: 'Standaardobstakel',
        customObstacle: 'Aangepast obstakel',
        bhp: 'Veiligheid en gezondheid op het werk',
        returnToMainPage: 'Terug naar hoofdpagina',
        bhpMessage:
            "Als u veiligheidsrisico's opmerkt, meld deze dan onmiddellijk aan uw directe leidinggevende en gebruik het meldingsformulier onder het publicatiebord.",
        ok: 'OK',
        send: 'Versturen',
        description: 'Beschrijving',
        title: 'Titel',
        realization: 'Uitvoering',
        answer: 'Antwoord',
        pendingSurveys: 'In behandeling zijnde enquêtes',
        surveys: 'Enquêtes',
        systemSurvey: 'Systeemenquête',
        addPage: 'Pagina toevoegen',
        createSurvey: 'Enquête maken',
        addSection: 'Sectie toevoegen',
        addQuestion: 'Vraag toevoegen',
        questionContent: 'Vraaginhoud',
        answerOption: 'Antwoordoptie',
        addQuestionAnswer: 'Antwoordoptie toevoegen',
        surveyName: 'Naam enquête',
        sectionName: 'Sectienaam',
        noSurveyAnswers: 'Geen antwoorden',
        removeSection: 'Sectie verwijderen',
        published: 'Gepubliceerd',
        unpublished: 'Niet gepubliceerd',
        pendingPublication: 'Wachten op publicatie',
        removeQuestion: 'Vraag verwijderen',
        removeAnswer: 'Antwoordoptie verwijderen',
        publish: 'Publiceren',
        unpublish: 'Publicatie intrekken',
        previewResults: 'Resultaten bekijken',
        supervisior: 'Leidinggevende',
        surveyResults: 'Enquêteresultaten',
        surveysEvents: 'Gebeurtenisconfiguratie - enquêtes',
        operatedBy: 'Geëxploiteerd door',
        confirmReadInformations: 'Ik bevestig dat ik de informatie heb gelezen',
        noticeContent: 'Berichtinhoud',
        notice: 'Bericht',
        surveyEventName: 'Gebeurtenisnaam',
        survey: 'Enquête',
        newIssue: 'Nieuw probleem',
        surveyEventConfigurationAlreadyExists:
            'De configuratie voor deze gebeurtenis bestaat al',
        lastComment: 'Laatste opmerking van de verantwoordelijke',
        surveyNotConfigured: 'Enquête niet geconfigureerd',
        fillSurvey: 'Enquête invullen',
        singleSurveyEntries: 'enkele resultaten',
        groupedSurveyEntries: 'Gegroepeerde resultaten',
        publicationId: 'Publicatie-ID',
        publicationDate: 'Datum van publicatie',
        versionId: 'versie-ID',
        answersCount: 'Aantal reacties',
        answers: 'Antwoorden',
        withoutSupervisor: 'Geen begeleider',
        defaultSupervisor: 'Standaard supervisor',
        flowStateFlags: 'Status vlaggen',
        qrActionsSettings: 'Actie-instellingen voor QR-codes',
        loginRequired: 'Vereist inloggen',
        questionContext: 'De context van de vraag',
        currentSurveyVersionPreview:
            'Preview van de huidige versie van de enquête',
        surveyDescription: 'Enquêtebeschrijving',
        sectionDescription: 'Sectiebeschrijving',
        instructions: 'Instructies',
        instruction: 'Instructie',
        instructionRevisions: 'Revisies',
        instructionRevision: 'Herziening',
        checklists: 'Controle lijsten',
        checklist: 'Controlelijst',
        checklistItem: 'Lijstitem',
        manageChecklistFields: 'Beheer lijstitems',
        checklistItemDisplayOptions: 'Getoonde artikelen',
        revisionAutoRejectedInfo:
            '[Systeem] Afgewezen - nieuwe revisie gemaakt',
    },
    checklists: {
        itemBasic: 'Basis element',
        itemSeparator: 'Scheidingsteken',
        itemSection: 'Sectie',
        publish: 'Publiceren',
        previewCurrentVersion: 'Preview van de huidige versie',
    },
};
